import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ServicesBookingConfirm } from '@components/templates/servicesCart';

export function ServicesBookingConfirmPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('services-booking-confirm-component.metatags.title'),
        description: t('services-booking-confirm-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.servicesBookingConfirm,
        index: false,
    });

    return <ServicesBookingConfirm />;
}
